import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/researchers/onboarding/')({
  beforeLoad: ({ context }) => {
    const belongsToAnOrg = context.orgs.length > 0;
    const isOnboardingComplete = context.user.jobTitle && context.user.source;

    throw redirect({
      to: !belongsToAnOrg
        ? '/researchers/onboarding/organization'
        : !isOnboardingComplete
          ? '/researchers/onboarding/personal'
          : '/researchers/projects',
    });
  },
});
